import { z } from "zod";

export const contactFormSchema = z.object({
	name: z.string().trim().min(2, "Informe seu nome."),
	email: z.email("Informe um e-mail valido."),
	message: z
		.string()
		.trim()
		.min(10, "A mensagem precisa ter pelo menos 10 caracteres."),
	website: z.string().optional(),
});

export const contactLocaleSchema = z.enum(["pt-BR", "en-US"]);

export type ContactFormValues = z.infer<typeof contactFormSchema>;
